'use es6';

export const FEATURES_SECTION = 600;
export const GUARANTEE_SECTION = 750;
export const TABLET_PORTRAIT = 800;